import * as React from "react";
import { EnvValues } from "../interfaces/customTypes/envValues";

export const defaultMockEnvValues: EnvValues = {
  firebasePublicKey: "",
  firebaseProjectId: "",
  firebaseFolder: "local",
  stripePublicKey: "",
  googleAnalyticsId: undefined,
};

export const EnvContext = React.createContext<EnvValues>(defaultMockEnvValues);
export const EnvContextProvider = EnvContext.Provider;
